import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'angular-toastify';
import { Subject, Observable } from 'rxjs';
import { MainFacade } from '../main.facade';

@Component({
  selector: 'app-mymissions',
  templateUrl: './mymissions.component.html',
  styleUrls: ['./mymissions.component.scss']
})
export class MymissionsComponent implements OnInit {

  private destroy$ = new Subject();
  public user$: Observable<any>|undefined;
  public onMissions$: Observable<any>|undefined;
  public claimable$: Observable<any>|undefined;
  public filter$: Observable<any>|undefined;
  user:any='';
  page:any=""

  constructor(private mainfacade:MainFacade, private sanitizer: DomSanitizer, private toastService: ToastService, private router:Router,private activeRoute:ActivatedRoute) { 
    
  }

 

 
  ngOnInit(): void {
    
    this.createSubscriptions();
  }




  ngOnDestroy() {
    this.destroy$.next(true);
  }

  
  createSubscriptions(){
    this.claimable$ = this.mainfacade.claimable$;
    this.onMissions$ = this.mainfacade.onMissions$;
    this.user$ = this.mainfacade.user$;
    this.filter$ = this.mainfacade.filter$;
    

   

  }

  setFilter(value){
    this.mainfacade.setFilter(value);
  }

 

}
